import { Component, OnInit, AfterViewInit } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { HackyService } from '../../_services/hacky.service';
import { StorageService } from '../../_services/storage.service';


@Component({
  selector: 'app-banner-cookies',
  templateUrl: './banner-cookies.component.html',
  styles: [],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({transform: 'translateY(100%)'}),
        animate('300ms ease-in', style({transform: 'translateY(0%)'}))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({transform: 'translateY(100%)'}))
      ])
    ])
  ]
})
export class BannerCookiesComponent implements OnInit {

  constructor(
    private storage: StorageService,
    private hacky: HackyService) { }

  show = false;

  necessari = true;
  hubspot = false;
  social = false;

  ngOnInit() {
    of({}).pipe(delay(200)).subscribe(() => {
      if (this.storage.getCookiesScaduti()) {
        this.show = true;
      }
    });
    this.hacky.openbannerCookies.subscribe(() => {
      this.show = true;
    });
  }



  chiudi(event) {
    event.preventDefault();
    this.storage.setAbilitazioneCookie('necessari', this.necessari);
    this.storage.setAbilitazioneCookie('hubspot', this.hubspot);
    this.storage.setAbilitazioneCookie('social', this.social);
    this.show = false;
  }

}
